import React, { useMemo } from 'react';
import { ThemeProvider } from '@emotion/react';
import { theme, Theme } from '@staffino/primitive-controls';

function mergeTheme(colors = {}) {
  return {
    ...theme,
    colors: {
      ...theme.colors,
      ...colors,
    },
  };
}

type Props = {
  colors?: Partial<Theme['colors']>;
  children?: React.ReactNode | React.ReactNodeArray;
};

const Provider = ({ colors, children }: Props) => {
  const mergedTheme = useMemo(() => mergeTheme(colors), [colors]);
  return <ThemeProvider theme={mergedTheme}>{children}</ThemeProvider>;
};

const ColorTheme = ({ colors, children }: Props) => {
  if (colors && typeof colors === 'object') {
    return <Provider colors={colors}>{children}</Provider>;
  }
  return <React.Fragment>{children}</React.Fragment>;
};

export default ColorTheme;
